export const BOOKING_DEFAULTS = {
  EMPTY_STRING: "-",
  EMPTY_CURRENCY_DISPLAY: "-",
  EMPTY_PRICE_DISPLAY: "0",

  // Default values
  DEFAULT_CURRENCY: "PKR",
  DEFAULT_AIRLINE_CODE: "default",
  STANDARD_SEAT_TYPE: "Standard",
  EMPTY_NUMBER: 0,

  // Airline logo base url

  AIRLINE_LOGO_BASE_URL:
    "https://s3.ap-south-1.amazonaws.com/st-airline-images/",

  // Default airline image
  DEFAULT_AIRLINE_IMAGE_URL:
    "https://s3.ap-south-1.amazonaws.com/st-airline-images/default.png",

  // Airport/Flight defaults
  NON_STOP_TEXT: "Non Stop",
  STOP_TEXT_SINGULAR: "stop",
  STOP_TEXT_PLURAL: "stops",

  // Route display formatting
  ROUTE_SEPARATOR: " → ",
  ROUTE_ROUND_TRIP_SYMBOL: " ⇄ ",
  ROUTE_VIA_PREFIX: " (via ",
  ROUTE_VIA_SUFFIX: ")",

  // Passenger defaults
  DEFAULT_PASSENGER_PREFIX: "Passenger",

  // Date/Time defaults
  DATE_DISPLAY_ERROR: "Invalid Date",

  // Empty collections
  EMPTY_ARRAY: [] as const,
} as const;

/** Error messages */
export const BOOKING_ERROR_MESSAGES = {
  MAPPING_ERROR: "Error in booking mapper",
  VALIDATION_ERROR: "Booking response validation failed",
  MISSING_CRITICAL_DATA: "Missing critical booking data",
  INVALID_SEGMENT: "Invalid segment data",
  INVALID_TRAVELER: "Invalid traveler data",
} as const;

/** Where to check booking status when top-level status is mixed / empty */
export const CHECK_STATUS_AT = {
  E_TICKETS: "E_TICKETS",
  SEGMENTS: "SEGMENTS",
} as const;

export type CheckStatusAt =
  (typeof CHECK_STATUS_AT)[keyof typeof CHECK_STATUS_AT];

export type CheckStatusAtTarget = {
  sectionId: string;
  label: string;
};

const CHECK_STATUS_AT_TARGETS: Record<string, CheckStatusAtTarget> = {
  E_TICKETS: { sectionId: "segmentTicketsSection", label: "E-Tickets" },
  E_TICKET: { sectionId: "segmentTicketsSection", label: "E-Tickets" },
  ETICKETS: { sectionId: "segmentTicketsSection", label: "E-Tickets" },
  "E-TICKETS": { sectionId: "segmentTicketsSection", label: "E-Tickets" },
  SEGMENTS: { sectionId: "segmentTicketsSection", label: "Segments" },
  SEGMENT: { sectionId: "segmentTicketsSection", label: "Segments" },
};

export const resolveCheckStatusAtTarget = (
  checkStatusAt?: string | null,
): CheckStatusAtTarget | null => {
  if (!checkStatusAt) return null;

  const normalized = checkStatusAt.trim().toUpperCase().replace(/\s+/g, "_");
  return (
    CHECK_STATUS_AT_TARGETS[normalized] || {
      sectionId: "ticketsSection",
      label: checkStatusAt.replaceAll("_", " "),
    }
  );
};
